import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import "./SelectdeliveryPage.css";
import pickup_store from "../../../assets/pickup_store.svg";
import home_delivery from "../../../assets/home_delivery.svg";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { maintainCartdata } from "../../home/redux/actions";
import { maintainStorelocation } from "../../home/redux/actions";
import { useTranslation } from "react-i18next";
import { maintanCheckoutpage } from "../../home/redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";
import close_cross from "../../../assets/close_cross.svg";
import { getRequestcall } from "../../comman/util/getRequest";
import { STOREDELIVERY_CHARGES } from "../../constants/apiurl";

function SelectdeliveryPage(props) {
  let geturlType = window.location.pathname.split("/").pop();
  const [storeFree, setStorefree] = useState(false);
  const [homedelivery, setHomedelivery] = useState(false);
  const [charge, setCharge] = useState();
  const [maxdistance, setMaxdistance] = useState();
  const [checkHomedelivery, setcheckHomedelivery] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const selectType = (type) => {
    if (type === "store") {
      setStorefree(true);
      setHomedelivery(false);
    } else {
      setHomedelivery(true);
      setStorefree(false);
    }
    let charges = type === "store" ? 0 : charge;
    // store type in redux
    let amount = {
      ...props.amount,
      order_delivery_type: type,
      charges: Number(charges),
    };
    props.maintainCartdata(props.cartdata, amount);
    let storelocation = {
      // Store location and max distance store in redux
      store_lat: props?.storelocation?.store_lat,
      store_lng: props?.storelocation?.store_lng,
      store_address: props?.storelocation?.store_address,
      delivery_max_distance: maxdistance,
    };
    props.maintainStorelocation(storelocation);
    setTimeout(navigateTonextpage, 50);
  };

  const navigateTonextpage = () => {
    if (props.access_token) {
      navigate("/checkout");
    } else {
      if (geturlType === "cart") {
        props.maintanCheckoutpage("checkout");
      } else {
        props.maintanCheckoutpage("cart");
      }
      navigate("/login");
    }
  };

  const openSelectdelivery = async () => {
    let responce = await getRequestcall(
      STOREDELIVERY_CHARGES + `/${props?.cartdata[0]?.store_id}`,
      props?.access_token
    );
    if (responce?.status === 200) {
      const resultStoreCharges = await responce?.json();
      setcheckHomedelivery(resultStoreCharges?.data?.home_delivery);
      let getList = resultStoreCharges?.data?.charges;
      if (getList.length !== 0) {
        let delivery_charge = 0;
        console.log("props?.amount?.total_amount", props?.amount?.total_amount)
        for (let index = 0; index < getList?.length; index++) {
          const Cost = Number(
            typeof props?.amount?.total_amount === "undefined"
              ? "00.00"
              : props?.amount?.total_amount +
                  (typeof props?.amount?.charges === "undefined"
                    ? 0
                    : props?.amount?.charges) -
                  (typeof props?.amount?.discount ===
                  "undefined"
                    ? 0
                    : props?.amount?.discount)
          ).toFixed(2)
          if (
            Cost >= Number(getList[index]?.min_price) &&
            Cost <= Number(getList[index]?.max_price)
          ) {
            delivery_charge = getList[index]?.delivery_charge;
            break;
          }
        }
        setMaxdistance(
          resultStoreCharges?.data?.delivery_max_distance === null
            ? 0
            : Number(resultStoreCharges?.data?.delivery_max_distance)
        );
        setCharge(delivery_charge);
      } else {
        setCharge(0);
      }
    }
  };

  const closeSelect = () => {
    props.setShowdelivery(false);
  };

  const colourStyles = {
    background: "white",
    right: "-8px",
    top: "-10px",
  };

  return (
    <Modal
      className="delivery_charge"
      show={props?.showdelivery}
      onShow={() => openSelectdelivery()}
      keyboard={false}
      restoreFocus={false}
      centered
    >
      <Modal.Body>
        <img
          src={close_cross}
          className="close-icon"
          onClick={() => closeSelect()}
          style={colourStyles}
          alt="close"
        ></img>
        <div>
          <h5>{t("pages.Select delivery type")}</h5>
          <div className="selection mt-4" onClick={() => selectType("store")}>
            <LazyLoadImage src={pickup_store} alt="" />
            <h4 className="ms-2">{t("pages.Pickup at store free")}</h4>
            <Form.Check
              id="pick-store"
              type="radio"
              className="select_delivery"
              checked={storeFree === true ? true : false}
            />
          </div>
          {checkHomedelivery === "yes" && (
            <div className="selection mt-4" onClick={() => selectType("home")}>
              <LazyLoadImage src={home_delivery} alt="" />
              <h4 className="ms-2">
                {t("pages.Home Delivery")} {charge}{" "}
                {process.env.REACT_APP_CURRENCY_SYMBOL}
              </h4>
              <Form.Check
                id="home-store"
                type="radio"
                className="select_delivery"
                checked={homedelivery === true ? true : false}
              />
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  amount: state?.home?.amount,
  cartdata: state?.home?.cartdata,
});

export default connect(mapStateToProps, {
  maintainCartdata,
  maintainStorelocation,
  maintanCheckoutpage,
})(SelectdeliveryPage);
